import '@/components/QuantitySelectorRegister';
import {logError} from '@/utilities/log';
import {z} from 'zod';

/**
 * Safely parse input with a fallback value if parsing fails.
 * Logs an error if parsing fails.
 *
 * @param schema - The Zod schema to use for parsing
 * @param fallback - The fallback value to use if parsing fails
 * @param input - The input to parse
 * @returns The parsed value or the fallback value
 */
export const safeParseOrElse = <T, U>(
  schema: z.ZodSchema<T>,
  fallback: T,
  input: U
) => {
  const result = schema.safeParse(input);
  if (!result.success) {
    logError(result.error, {
      message: 'ErrorParsingInput',
      issues: result.error.issues,
    });
    return fallback;
  }
  return result.data;
};
